import gql from 'graphql-tag';

/* ---------------------------------------------------------------- */
/* ----------------------- Appparams (read-only) ------------------ */
/* ---------------------------------------------------------------- */
export const gqlGetAppparams = gql`
  query getAppparams($limit: Int, $offset: Int, $order: String, $where: String) {
    getAppparams(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        paramName
        paramGroup
        paramValue
        description
        notes
        firstDate
        firstUser
        lastDate
        lastUser
      }
      recordCount
    }
  }
`;

/* ---------------------------------------------------------------- */
/* ----------------------- EntityParams (editable) ---------------- */
/* ---------------------------------------------------------------- */
export class EntityParamFormInput {
  id: number;
  paramName: string;
  entityType: string;
  intValue: number;
  applies: boolean;

  constructor() {
    this.id = undefined;
    this.paramName = undefined;
    this.entityType = undefined;
    this.intValue = undefined;
    this.applies = undefined;
  }
}

export const gqlGetEntityParams = gql`
  query getEntityParams($limit: Int, $offset: Int, $order: String, $where: String) {
    getEntityParams(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        paramName
        paramGroup
        entityType
        intValue
        applies
        firstDate
        firstUser
        lastDate
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlGetEntityParamGroups = gql`
  query getEntityParamGroups {
    getEntityParamGroups {
      value
      label
    }
  }
`;

export const gqlAddEntityParam = gql`
  mutation addEntityParam($data: EntityParamInput) {
    addEntityParam(data: $data) {
      id
    }
  }
`;

export const gqlUpdateEntityParam = gql`
  mutation updateEntityParam($data: EntityParamInput) {
    updateEntityParam(data: $data) {
      id
    }
  }
`;

export const gqlDeleteEntityParam = gql`
  mutation deleteEntityParam($id: Int) {
    deleteEntityParam(id: $id)
  }
`;
